/**
 * Cookie name for device fingerprint.
 */
export const FINGERPRINT_COOKIE_NAME = 'x-device-fingerprint'
